<!--eslint-disable-->
<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="Análise" name="analise"><AnaliseComponent></AnaliseComponent></el-tab-pane>
    <!-- <el-tab-pane label="Quadro Geral" name="quadro-geral"><QuadroGeral></QuadroGeral></el-tab-pane> -->
    <el-tab-pane label="Formulário" name="monitor-qualidade"><MonitorQualidade></MonitorQualidade></el-tab-pane>
    <!-- <el-tab-pane label="Monitor - Valuation" name="monitor-valuation">Valuation</el-tab-pane> -->
  </el-tabs>
</template>

<script>
/* eslint-disable */
import AnaliseComponent from '@/components/Monitor/Analise'
import ComponentExample from '@/components/ComponentExample'
import MonitorQualidade from '@/components/Monitor/MonitorQualidade';
import QuadroGeral from '@/components/Monitor/QuadroGeral';

  export default {
    data() {
      return {
        activeName: 'analise'
      };
    },
    components: {
        'AnaliseComponent': AnaliseComponent,
        'MonitorQualidade': MonitorQualidade,
        'ComponentExample': ComponentExample,
        'QuadroGeral': QuadroGeral
    },
    methods: {

    }
  };
</script>